import React, {useContext, useEffect, useState} from "react";

import {AuthenticatedTemplate, UnauthenticatedTemplate, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig.js";

import {FetchContext, NavContext} from "../contexts";

import {AppBar, Box, Breadcrumbs, Button, Container, Grid, Link, Stack, Toolbar, Typography,} from "@mui/material";

import {Link as RouterLink} from "react-router-dom";

import logoRepubblica from "../../images/logo-repubblica-bianca.png";

const LinkRouter = (props) => <Link {...props} component={RouterLink}/>;

export const Layout = (props) => {
    const {instance, accounts} = useMsal();

    const {user} = useContext(FetchContext);

    const [name, setName] = useState(null);

    useEffect(() => {
        if (accounts.length > 0) {
            setName(
                accounts[0].idTokenClaims.given_name +
                " " +
                accounts[0].idTokenClaims.family_name
            );
        } else {
            setName(null);
        }
    }, [accounts]);

    const handleLogin = () => {
        instance.loginRequest = loginRequest;
        instance.loginRedirect();
    };

    const handleLogout = () => {
        instance.logoutRedirect();
    };

    const {menuItems, breadcrumbs} = useContext(NavContext);

    const boxSX = {
        color: "whitesmoke",
        backgroundColor: "secondary.main",

        "&:hover": {
            backgroundColor: "secondary.light",

            //backgroundColor: 'lightblue'
        },
    };

    return (
        <>
            <main
                style={{
                    position: "relative",
                    minHeight: "calc(100vh - 150px)",
                }}
            >
                <Box sx={{flexGrow: 1}}>
                    <AppBar position="static" sx={{boxShadow: "none"}}>
                        <Container>
                            <Toolbar variant="dense" sx={{padding: "0px!important"}}>
                                <Grid container>
                                    <a
                                        href="https://www.giustizia.it/"
                                        style={{
                                            textDecoration: "none",
                                        }}
                                    >
                                        <Typography
                                            fontSize=".778em"
                                            fontWeight={600}
                                            sx={{width: "50%", color: "white", whiteSpace: "nowrap"}}
                                        >
                                            Ministero della Giustizia
                                        </Typography>
                                    </a>
                                </Grid>
                                <Grid
                                    container
                                    alignItems="center"
                                    justifyContent="flex-end"
                                    sx={{margin: 0}}
                                >
                                    <UnauthenticatedTemplate>
                                        <Button
                                            onClick={() => handleLogin()}
                                            key="logoutRedirect"
                                            sx={boxSX}
                                        >
                                            Accedi
                                        </Button>
                                    </UnauthenticatedTemplate>
                                    <AuthenticatedTemplate>
                                        <Typography
                                            fontSize={19}
                                            fontWeight={500}
                                            sx={{marginRight: 4}}
                                        >
                                            {name}
                                        </Typography>
                                        <Button
                                            onClick={() => handleLogout()}
                                            key="logoutRedirect"
                                            sx={boxSX}
                                        >
                                            Esci
                                        </Button>
                                    </AuthenticatedTemplate>
                                </Grid>
                            </Toolbar>
                        </Container>
                    </AppBar>
                </Box>
                <Box sx={{flexGrow: 1, paddingY: 2, backgroundColor: "#06c"}}>
                    <Container>
                        <a
                            href="./"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                            }}
                        >
                            <img
                                src={logoRepubblica}
                                style={{width: 157, marginLeft: "-30px"}}
                            />
                            <Grid container>
                                <Grid item xs={12} sx={{marginBottom: 0}}>
                                    <Typography sx={{fontSize: "1.9em", color: "white"}}>
                                        Giustizia Map
                                    </Typography>
                                </Grid>
                            </Grid>
                        </a>
                    </Container>
                </Box>
                <Box
                    sx={{flexGrow: 1, backgroundColor: "secondary.main", padding: 2}}
                >
                    <Container>
                        <Stack direction="row" spacing={4} padding={0}>
                            {menuItems
                                .filter((x) => !x.utility)
                                .map((item, index) => (
                                    <Button
                                        key={index}
                                        sx={{color: "white", textTransform: "none", padding: 0}}
                                        onClick={item.onClick}
                                    >
                                        <Typography fontSize={17}>{item.label}</Typography>
                                    </Button>
                                ))}
                            {menuItems
                                .filter((x) => x.utility)
                                .map((item, index) => {
                                    if (item.isProtected)
                                        return (
                                            <AuthenticatedTemplate>
                                                <Button
                                                    key={
                                                        index +
                                                        menuItems.filter((x) => !x.utility)?.length ?? 0
                                                    }
                                                    sx={{
                                                        color: "white",
                                                        textTransform: "none",
                                                        padding: 0,
                                                        marginLeft: `${
                                                            index == 0 ? "auto !important" : null
                                                        }`,
                                                    }}
                                                    onClick={item.onClick}
                                                >
                                                    <Typography fontSize={17}>{item.label}</Typography>
                                                </Button>
                                            </AuthenticatedTemplate>
                                        );
                                    else
                                        return (
                                            <Button
                                                key={
                                                    index + menuItems.filter((x) => !x.utility)?.length ??
                                                    0
                                                }
                                                sx={{
                                                    color: "white",
                                                    textTransform: "none",
                                                    padding: 0,
                                                    marginLeft: `${
                                                        index == 0 ? "auto !important" : null
                                                    }`,
                                                }}
                                                onClick={item.onClick}
                                            >
                                                <Typography fontSize={17}>{item.label}</Typography>
                                            </Button>
                                        );
                                })}
                        </Stack>
                    </Container>
                </Box>
                <Container
                    sx={{marginY: breadcrumbs && breadcrumbs.length > 0 ? 2 : 0}}
                >
                    <Breadcrumbs aria-label="breadcrumb" color="inherit">
                        {breadcrumbs &&
                            breadcrumbs.length > 0 &&
                            breadcrumbs.map((token, index) => {
                                if (index < breadcrumbs.length - 1) {
                                    return (
                                        <LinkRouter key={index} color="inherit" to={token.url}>
                                            {token.title}
                                        </LinkRouter>
                                    );
                                } else {
                                    return (
                                        <Typography key={index} color="inherit">
                                            {token.title}
                                        </Typography>
                                    );
                                }
                            })}
                    </Breadcrumbs>
                </Container>
                {props.children}
            </main>
            <footer>
                <Box
                    sx={{backgroundColor: "secondary.main", paddingY: 3, marginTop: 3}}
                >
                    <Container>
                        <Grid container>
                            <Grid item xs="auto">
                                <a
                                    href="./"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        textDecoration: "none",
                                    }}
                                >
                                    <img
                                        src={logoRepubblica}
                                        style={{width: 157, marginLeft: "-30px"}}
                                    />
                                </a>

                            </Grid>
                            <Grid item xs container>
                                <Grid
                                    item
                                    xs={12}
                                    sx={{marginBottom: 0, marginLeft: "-20px"}}
                                >
                                    <a
                                        href="https://www.giustizia.it"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            textDecoration: "none",
                                        }}
                                    >
                                        <Typography sx={{fontSize: "1.2em", color: "white"}}>
                                            Ministero della Giustizia
                                        </Typography>
                                    </a>
                                    <a
                                        href="./"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            textDecoration: "none",
                                        }}
                                    >
                                        <Typography
                                            sx={{fontSize: "0.9em", color: "white", marginTop: 1}}
                                        >
                                            Giustizia MAP
                                        </Typography>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            </footer>
        </>
    );
};
